// src/layouts/ResourcePersonLayout.jsx (or wherever you prefer to store layouts)
import React from "react";
import {Outlet} from "react-router-dom";
import NavBar from "../components/LNavbar"; // Assuming you have a NavBar component
import {SidebarProvider} from "../components/ui/sidebar";
import {AppSidebar} from "../components/AppSidebar";

function ResourcePersonLayout() {
  React.useEffect(() => {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.info("[auth] resource-person layout mounted");
    }
  }, []);

  return (
    <SidebarProvider>
      <div className="resource-person-dashboard flex w-full min-h-screen bg-background text-foreground">
        {/* Sidebar */}
        <AppSidebar />

        {/* Main Area */}
        <div className="flex-1 flex flex-col">
          <div className="sticky top-0 z-50 bg-background">
            <NavBar />
          </div>

          <main className="flex-1 p-6 mt-12 overflow-auto">
            {/* The Outlet component will render the matched child route component */}
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}

export default ResourcePersonLayout;